'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DELETE = exports.DELETE = 'DELETE';
var GET = exports.GET = 'GET';
var HEAD = exports.HEAD = 'HEAD';
var POST = exports.POST = 'POST';
var PUT = exports.PUT = 'PUT';
var PATCH = exports.PATCH = 'PATCH';